/*
 *   File : fund-details.js
 *   Author : https://evoqins.com
 *   Description : Fund Details modal
 *   Integrations :
 *   Version : 1.0.0
*/

import { memo, useState } from "react";


import { Icon } from "../Icon";
import Colors from "../../Style/color.scss";

const FundDetailsModal = (props) => {

    const [showCurrent, setShowCurrent] = useState(true);


    return (
        <div className="modal fade e-manage-modal"
            id="fund-details-modal"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="Fund Details Modal Label"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable px-lg-5">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                    <div className="modal-header justify-content-between pt-3  px-3 pb-0 border-0">
                        <h6 className='e-font-16-res mb-2 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            Fund Details
                        </h6>
                        <img src={require("../../Assets/Images/close-btn-white.svg").default}
                            id='logout-confirmation-modal-close'
                            draggable={false}
                            className='cursor-pointer'
                            data-bs-dismiss="modal"
                            aria-label="close"
                            alt='close btn'
                            onClick={props.onClose} />
                    </div>
                    <div className="modal-body p-3">

                        <div className="d-flex justify-content-end mb-3">
                            <div className="d-flex cursor-pointer" onClick={() => setShowCurrent(prev => !prev)}>
                                <Icon icon="arrow-right-allocation" color={Colors.egyptian_blue} size={12} className="transform-rotate-180" />
                                <Icon icon="arrow-right-allocation" color={Colors.egyptian_blue} size={12} />
                            </div>
                            <span className='ms-1 e-text-egyptian-blue e-primary-font-inter  e-font-10 e-font-weight-500 line-height-14px'>
                                {showCurrent ? "Current(invested)" : "Invested(Current)"}
                            </span>
                        </div>

                        <div className="d-flex flex-column gap-12px">
                            {
                                props.funds.map((item, index) => (
                                    <div key={index} className="d-flex gap-2 justify-content-between e-border-1px-crystal-blue e-bg-alice-blue e-border-radius-16  padding-12px-all">
                                        <img src={item.icon}
                                            className="e-bg-white object-fit-contain e-border-radius-6 h-32 w-32px width-24px-res py-1 object-fit-contain"
                                            draggable="false"
                                            alt="fund" />

                                        <div className="flex-fill">
                                            <h3 className="e-ellipse mb-1 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-16px pe-lg-4">
                                                {item.fund_name}
                                            </h3>
                                            {
                                                item.is_sip &&
                                                <span className={`e-text-charleston-green e-bg-crystal-peak px-1 padding-2px-tb e-border-radius-4 e-font-10 e-primary-font-inter e-font-weight-400`} >
                                                    SIP
                                                </span>
                                            }
                                        </div>
                                        <div className="d-flex flex-column align-items-center">
                                            <span className="e-text-eerie-black e-primary-font-inter  e-font-12 e-font-weight-500 line-height-22px">
                                                {showCurrent ? item.current_amount_text : item.invested_amount_text}
                                            </span>
                                            <span className="e-text-trout e-primary-font-inter e-font-10 e-font-weight-400 line-height-14px">
                                                ({showCurrent ? item.invested_amount_text : item.current_amount_text})
                                            </span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(FundDetailsModal);